/* eslint-disable */
import Vue from 'vue'
import { getNotifications, createNotifications, findNotificationsByUsers} from '@/common/services/modules/notifications'

const getDefaultRecurrence = () => {
	return {
		description: '',
		numberOfTimesPerPeriod: 0,
		periodRange: '',
		daysOfWeek: [],
		dueStrategy: {
			method: '',
			dateToFinish: Date,
			totalToSend: 0
		}
	}
}

const getDefaultState = () => {
	return {
		scheduleRecurrency: {
			visibleRecurrencyModal: false,
			recurrence: getDefaultRecurrence()
		},
		sendNotification: {
			visibleConfirmationModal: false,
			payload: undefined
		},
		sentNotification: {
			visible: false,
			success: false,
		},
		visibleModalRemoveNotification: {
			visible: false,
			id: null,
			isRead: false
		},
		listNotifications: [],
		loadingNotifications: false,
		notificationsSentByUser: [],
		quantity: 0,
		loading: false
	}
}

export default {
	namespaced: true,
	state: getDefaultState(),
	getters: {
		getRecurrencyMessage(state) {
			return state.scheduleRecurrency.recurrence.description
		},
		getRecurrence(state) {
			return state.scheduleRecurrency.recurrence
		}
	},
	mutations: {
		UPDATE_SEND_NOTIFICATION(state, { visibleConfirmationModal, payload = undefined }) {
			Object.assign(state.sendNotification, { visibleConfirmationModal, payload })
		},
		UPDATE_SENT_NOTIFICATION(state, payload) {
			Object.assign(state.sentNotification, payload)
		},
		CLEAR_NOTIFICATIONS(state) {
			Object.assign(state, getDefaultState())
		},
		VISIBLE_MODAL_RECURRENCY(state, visible) {
			state.scheduleRecurrency.visibleRecurrencyModal = visible
		},
		VISIBLE_MODAL_REMOVE_NOTIFICATION(state, parms) {
			Vue.set(state.visibleModalRemoveNotification, 'visible', parms.visible)
			Vue.set(state.visibleModalRemoveNotification, 'id', parms.id)
			Vue.set(state.visibleModalRemoveNotification, 'isRead', parms.isRead)
		},
		UPDATE_NOTIFICATION(state, notification) {
			state.listNotifications = notification
		},
		UPDATE_SENT_BY_USER(state, notification) {
			state.notificationsSentByUser = notification
		},
		REMOVE_NOTIFICATION(state, id) {
			const newList = state.listNotifications.filter(
				(notifications) => notifications.id !== id
			)

			if (newList.length < 1) return

			state.listNotifications = newList

			Vue.set(state.visibleModalRemoveNotification, 'visible', false)
			Vue.set(state.visibleModalRemoveNotification, 'id', null)
		},
		CHANGE_STATUS_NOTIFICATION(state, id) {
			const findIndexNotification = state.listNotifications.findIndex((notifications) => notifications.id === id)
			const notification = state.listNotifications.find((notifications) => notifications.id === id)

			if (!notification) return

			notification.isRead = true
			Vue.set(state.listNotifications, findIndexNotification, notification)
		},
		UPDATE_QTDE_NOTIFICATION(state, { quantity = 0, mounted = false }) {
			if (!mounted) {
				state.quantity = state.quantity - 1
				return
			}
			state.quantity = quantity
		},
		TOGGLE_LOADING_WIDGET(state, isLoading) {
			state.loadingNotifications = isLoading
		},
		SET_LOADING(state, isLoading) {
			state.loading = isLoading
		},
		SET_RECURRENCY(state, recurrence) {
			return state.scheduleRecurrency.recurrence = recurrence
		},
		UPDATE_RECURRENCY_MESSAGE(state, message) {
			return state.scheduleRecurrency.recurrence.description = message
		},
		RESET_RECURRENCY(state) {
			return state.scheduleRecurrency.recurrence = getDefaultRecurrence()
		}

	},
	actions: {
		async sendNotifications({ commit }, payload) {
			try {
				await createNotifications(payload)
				commit('UPDATE_SENT_NOTIFICATION', {
					visible: true,
					success: true
				})
			} catch (error) {
				commit('UPDATE_SENT_NOTIFICATION', {
					visible: true,
					success: false
				})
			}

			finally {
				commit('UPDATE_SEND_NOTIFICATION', { visibleConfirmationModal: false })
			}

		},
		async getNotifications({ state, commit }, params) {
			const { data: { result, qtde: quantity } } = await getNotifications(params)
			const currentStateListNotifications = state.listNotifications
			const isEmptyCurrentState = currentStateListNotifications.length < 1

			if (isEmptyCurrentState) return state.listNotifications = result

			const newNotifications = []
			const searchNotificationInCurrentState = (id) => currentStateListNotifications
				.find(notificationCurrentState => id === notificationCurrentState.id)

			for (const notification of result) {
				if (!searchNotificationInCurrentState(notification.id)) {
					newNotifications.push(notification)
				}
			}

			state.listNotifications = state.listNotifications.concat(newNotifications)

			commit('UPDATE_QTDE_NOTIFICATION', { quantity, mounted: true })
			return result
		},
		async getNotificationsInterval({ state, commit }, params) {
			commit('SET_LOADING', true)
			const { data } = await getNotifications(params)
			const result = data.result
			const quantity = data.qtde
			commit('UPDATE_NOTIFICATION', result)
			commit('SET_LOADING', false)
			commit('UPDATE_QTDE_NOTIFICATION', { quantity, mounted: true })
		},
		async updateNotificationsSentByUser({commit, dispatch}) {
			const notificationsList = await findNotificationsByUsers()
			commit('UPDATE_SENT_BY_USER', notificationsList.data)
			return notificationsList
		},
		updateRecurrencyMessage({commit}, params) {
			commit('UPDATE_RECURRENCY_MESSAGE', params)
		},
		resetRecurrency({commit}) {
			commit('RESET_RECURRENCY')
		},
		updateRecurrencyPayload({commit}, params) {
			commit('SET_RECURRENCY', params)
		}
	}
}
